import styled from '@emotion/styled';
import Button, { LoadingButtonProps } from '@atlaskit/button/loading-button';
import { LinkButton, LinkButtonProps } from '@atlaskit/button/new';
import React from 'react';
import { LinkProps } from 'react-router-dom';

const StyledButton = styled(Button)`
  height: 40px !important;
  line-height: 40px !important;

  div,
  span {
    display: flex !important;
    justify-content: center;
  }
`;

const StyledLinkButtonWrapper = styled.div`
  a {
    height: 40px !important;
    line-height: 40px !important;
  }
`;

export interface TallButtonProps extends LoadingButtonProps {
  isFullWidth?: boolean;
}

export default function TallButton(props: TallButtonProps) {
  const { isFullWidth, ...rest } = props;
  return <StyledButton {...rest} shouldFitContainer={isFullWidth} />;
}

export interface TallLinkButtonProps extends LinkButtonProps<LinkProps> {
  isFullWidth?: boolean;
}

export const TallLinkButton = (props: TallLinkButtonProps) => {
  const { isFullWidth, ...rest } = props;
  return (
    <StyledLinkButtonWrapper>
      <LinkButton<LinkProps> {...rest} shouldFitContainer={isFullWidth} />
    </StyledLinkButtonWrapper>
  );
};
